export const memberships = [
  {
    name: "ESSENTIALS",
    reach: "1 MILLION REACH",
    star: 1,
    type: "essentials" as const,
    popular: false,
    features: [
      {
        heading: "Suitable for small companies with:",
        options: [
          {
            tooltip: "",
            text: "Employer profile on the site",
          },
          {
            tooltip: "",
            text: "100 monthly jobs limit",
          },
          {
            tooltip:
              "Your jobs are automatically collected from your \n careers site or ATS — no manual posting needed.",
            text: "Automated job posting in 1 country",
          },
        ],
      },
      {
        heading: "Talent Attraction & Online Visibility",
        options: [
          {
            tooltip: "",
            text: "Employer profile on the site",
          },
          {
            tooltip: "",
            text: "Access to DE&I resources through dashboard",
          },
          {
            tooltip:
              "Your jobs are automatically collected from your careers site or ATS — no manual posting needed.",
            text: "Automated job posting in 1 country",
          },
          {
            tooltip: "",
            text: "100 monthly jobs limit",
          },
          {
            tooltip: "",
            text: "Ability to post content (articles & events) on the site",
          },
          {
            tooltip: "",
            text: "Annual engagement dashboard",
          },
        ],
      },
      {
        heading: "Education & Training",
        options: [
          {
            tooltip: "Mixed group training for all myGwork partners",
            text: "Access to 4 DE&I training webinars",
          },
          {
            tooltip:
              "Comes with a full (1-year) licence and an unlimited licence limit.",
            text: "Access to 1 myGwork Academy e-learning module",
          },
          {
            tooltip: "",
            text: "10% Discount on additional myGwork Academy e-Learning courses",
          },
        ],
      },
    ],
  },
  {
    name: "BRONZE",
    reach: "3 MILLION REACH",
    star: 2,
    type: "bronze" as const,
    popular: false,
    features: [
      {
        heading: "Suitable for growing teams with:",
        options: [
          {
            tooltip: "",
            text: "250 monthly jobs limit",
          },
          {
            tooltip:
              "Your jobs are automatically collected from your careers site or ATS — no manual posting needed.",
            text: "Regional automated job posting",
          },
          {
            tooltip: "",
            text: "Participate in 1 monthly myGwork Intersectionality Webinar & Employee Article Feature",
          },
        ],
      },
      {
        heading: "Talent Attraction & Online Visibility",
        options: [
          {
            tooltip: "",
            text: "Employer profile on the site",
          },
          {
            tooltip: "",
            text: "Access to DE&I resources through dashboard",
          },
          {
            tooltip:
              "Your jobs are automatically collected from your careers site or ATS — no manual posting needed.",
            text: "Regional automated job posting",
          },
          {
            tooltip: "",
            text: "250 monthly jobs limit",
          },
          {
            tooltip: "",
            text: "Ability to post content (articles & events) on the site",
          },
          {
            tooltip: "",
            text: "Annual engagement dashboard",
          },
        ],
      },
      {
        heading: "360° Employer Branding",
        options: [
          {
            tooltip: "",
            text: "Participate in 1 monthly myGwork Intersectionality Webinar & Employee Article Feature",
          },
        ],
      },
      {
        heading: "Education & Training",
        options: [
          {
            tooltip: "Mixed group training for all myGwork partners",
            text: "Access to 4 DE&I training webinars",
          },
          {
            tooltip: "",
            text: "Access to 1 myGwork Academy e-learning module",
          },
          {
            tooltip: "",
            text: "10% Discount on additional myGwork Academy e-Learning courses",
          },
        ],
      },
    ],
  },
  {
    name: "SILVER",
    reach: "5 MILLION REACH",
    star: 3,
    type: "silver" as const,
    popular: false,
    features: [
      {
        heading: "Suitable for mid-sized companies with:",
        options: [
          {
            tooltip: "",
            text: "1000 monthly jobs limit",
          },
          {
            tooltip:
              "Premium job listings are featured in our newsletter and promoted on LinkedIn.",
            text: "Premium job listing",
          },
          {
            tooltip:
              "Your jobs are automatically collected from your careers site or ATS — no manual posting needed.",
            text: "Global automated job posting",
          },
          {
            tooltip: "",
            text: "Advanced annual engagement report",
          },
        ],
      },
      {
        heading: "Talent Attraction & Online Visibility",
        options: [
          {
            tooltip: "",
            text: "Employer profile on the site",
          },
          {
            tooltip: "",
            text: "Access to DE&I resources through dashboard",
          },

          {
            tooltip:
              "Your jobs are automatically collected from your careers site or ATS — no manual posting needed.",
            text: "Global automated job posting",
          },

          {
            tooltip: "",
            text: "1000 monthly jobs limit",
          },
          {
            tooltip:
              "Premium job listings are featured in our newsletter and promoted on LinkedIn.",
            text: "Premium job listing",
          },
          {
            tooltip: "",
            text: "Ability to post content (articles & events) on the site",
          },
          {
            tooltip: "",
            text: "Customer Success Manager support",
          },
          {
            tooltip: "",
            text: "Advanced annual engagement report",
          },
        ],
      },
      {
        heading: "360° Employer Branding",
        options: [
          {
            tooltip: "",
            text: "1 Article in global LGBTQ+ magazine(s)",
          },
          {
            tooltip: "",
            text: "Logo included in myGwork marketing materials",
          },
          {
            tooltip: "",
            text: "Participate in 1 monthly myGwork Intersectionality Webinar & Employee Article Feature",
          },
        ],
      },
      {
        heading: "Employee Engagement and Events",
        options: [
          {
            tooltip: "Global Virtual Pride Conference",
            text: "1 panellist at our WorkPride conference",
          },
        ],
      },
      {
        heading: "Education & Training",
        options: [
          {
            tooltip: "Mixed group training for all myGwork partners",
            text: "Access to 4 DE&I training webinars",
          },
          {
            tooltip: "",
            text: "1 DE&I webinar exclusive for your company",
          },
          {
            tooltip: "",
            text: "Access to 1 myGwork Academy e-learning module",
          },
          {
            tooltip: "",
            text: "20% Discount on additional myGwork Academy e-Learning courses",
          },
        ],
      },
    ],
  },
  {
    name: "GOLD",
    reach: "20 MILLION REACH",
    star: 4,
    type: "gold" as const,
    popular: true,
    features: [
      {
        heading: "Suitable for larger companies with:",
        options: [
          {
            tooltip: "",
            text: "Unlimited monthly jobs limit",
          },
          {
            tooltip:
              "Premium job listings are featured in our newsletter and promoted on LinkedIn.",
            text: "Premium job listing",
          },
          {
            tooltip:
              "Your jobs are automatically collected from your careers site or ATS — no manual posting needed.",
            text: "Global automated job posting",
          },
          {
            tooltip:
              "Your organisation and jobs will be highlighted on our homepage, newsletter, and promoted on our LinkedIn page during your featured week.",
            text: "Featured as Organisation of the week",
          },
          {
            tooltip: "",
            text: "2 DE&I webinars exclusive for your company",
          },
        ],
      },
      {
        heading: "Talent Attraction & Online Visibility",
        options: [
          {
            tooltip: "",
            text: "Employer profile on the site",
          },
          {
            tooltip: "",
            text: "Access to DE&I resources through dashboard",
          },

          {
            tooltip:
              "Your jobs are automatically collected from your careers site or ATS — no manual posting needed.",
            text: "Global automated job posting",
          },

          {
            tooltip: "",
            text: "Unlimited monthly jobs limit",
          },
          {
            tooltip:
              "Your organisation and jobs will be highlighted on our homepage, newsletter, and promoted on our LinkedIn page during your featured week.",
            text: "Featured as Organisation of the week",
          },

          {
            tooltip:
              "Premium job listings are featured in our newsletter and promoted on LinkedIn.",
            text: "Premium job listing",
          },
          {
            tooltip: "",
            text: "Ability to post content (articles & events) on the site",
          },
          {
            tooltip: "",
            text: "Customer Success Manager support",
          },
          {
            tooltip: "",
            text: "Competitive annual engagement report",
          },
        ],
      },
      {
        heading: "360° Employer Branding",
        options: [
          {
            tooltip: "",
            text: "1 Article in global LGBTQ+ magazine(s)",
          },
          {
            tooltip: "",
            text: "Logo included in myGwork marketing materials",
          },
          {
            tooltip: "",
            text: "Participate in 2 monthly myGwork Intersectionality Webinars & Employee Article Features",
          },
        ],
      },
      {
        heading: "Employee Engagement and Events",
        options: [
          {
            tooltip:
              "A global virtual career fair for LGBTQ+ students and recent graduates",
            text: "WorkFair booth",
          },
          {
            tooltip: "Global Virtual Pride Conference",
            text: "1 webinar + 1 panellist at our WorkPride conference",
          },
          {
            tooltip:
              "We work with industry speakers and assist in sourcing the right match for your event.",
            text: "Access to industry speakers",
          },
        ],
      },
      {
        heading: "Education & Training",
        options: [
          {
            tooltip: "Mixed group training for all myGwork partners",
            text: "Access to 4 DE&I training webinars",
          },
          {
            tooltip: "",
            text: "2 DE&I webinars exclusive for your company",
          },
          {
            tooltip: "",
            text: "Access to 1 myGwork Academy e-learning module",
          },
          {
            tooltip: "",
            text: "30% Discount on additional myGwork Academy e-Learning courses",
          },
        ],
      },
    ],
  },
  {
    name: "PLATINUM",
    reach: "20 MILLION REACH",
    star: 5,
    type: "platinum" as const,
    popular: false,
    features: [
      {
        heading: "Suitable for enterprise organizations with:",
        options: [
          {
            tooltip: "",
            text: "Unlimited monthly jobs limit",
          },
          {
            tooltip:
              "Premium job listings are featured in our newsletter and promoted on LinkedIn.",
            text: "Premium job listing",
          },
          {
            tooltip:
              "Your jobs are automatically collected from your careers site or ATS — no manual posting needed.",
            text: "Global automated job posting",
          },
          {
            tooltip:
              "Your organisation and jobs will be highlighted on our homepage, newsletter, and promoted on our LinkedIn page during your featured week.",
            text: "Featured as Organisation of the week",
          },
          {
            tooltip: "",
            text: "2 Articles in global LGBTQ+ magazine(s)",
          },
          {
            tooltip: "",
            text: "3 DE&I webinars exclusive for your company",
          },
        ],
      },
      {
        heading: "Talent Attraction & Online Visibility",
        options: [
          {
            tooltip: "",
            text: "Employer profile on the site",
          },
          {
            tooltip: "",
            text: "Access to DE&I resources through dashboard",
          },

          {
            tooltip:
              "Your jobs are automatically collected from your careers site or ATS — no manual posting needed.",
            text: "Global automated job posting",
          },

          {
            tooltip: "",
            text: "Unlimited monthly jobs limit",
          },
          {
            tooltip:
              "Your organisation and jobs will be highlighted on our homepage, newsletter, and promoted on our LinkedIn page during your featured week.",
            text: "Featured as Organisation of the week",
          },

          {
            tooltip:
              "Premium job listings are featured in our newsletter and promoted on LinkedIn.",
            text: "Premium job listing",
          },
          {
            tooltip: "",
            text: "Ability to post content (articles & events) on the site",
          },
          {
            tooltip: "",
            text: "Customer Success Manager support",
          },
          {
            tooltip: "",
            text: "Competitive annual engagement report",
          },
        ],
      },
      {
        heading: "360° Employer Branding",
        options: [
          {
            tooltip: "",
            text: "2 Articles in global LGBTQ+ magazine(s)",
          },
          {
            tooltip: "",
            text: "Logo included in myGwork marketing materials",
          },
          {
            tooltip: "",
            text: "Participate in 3 monthly myGwork Intersectionality Webinars & Employee Article Features",
          },
        ],
      },
      {
        heading: "Employee Engagement and Events",
        options: [
          {
            tooltip:
              "A global virtual career fair for LGBTQ+ students and recent graduates",
            text: "WorkFair booth",
          },
          {
            tooltip:
              "The largest virtual global conference dedicated to workplace inclusion",
            text: "Platinum sponsor at our WorkPride conference",
          },
          {
            tooltip:
              "We work with industry speakers and assist in sourcing the right match for your event.",
            text: "Access to industry speakers",
          },
        ],
      },
      {
        heading: "Education & Training",
        options: [
          {
            tooltip: "Mixed group training for all myGwork partners",
            text: "Access to 4 DE&I training webinars",
          },
          {
            tooltip: "",
            text: "3 DE&I webinars exclusive for your company",
          },
          {
            tooltip:
              "Comes with a full (1-year) licence and an unlimited licence limit.",
            text: "Access to all myGwork Academy e-learning modules",
          },
        ],
      },
    ],
  },
];
